import CheckIcon from "@mui/icons-material/Check";
import { Button } from "@mui/material";
import { Spin } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { PsLabel } from "../../../components";
import PsModalWindow from "../../../components/PsModalWindow";
import PsContext from "../../../context";
import { useDialog } from "../../../context/DialogContext";
import { formToObject } from "../../../utils";

import { _UPDATE_USER_LOGIN } from "../../../models/userLoginModel";
import { _LIST_AGENCIES } from "../../../models/agenciesModel";

const EditUserLoginFormComponent = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);
  const [validated, setValidated] = useState(false);
  const [agents, setAgents] = useState([]);

  const { openDialog } = useDialog();

  useEffect(() => {
    listAgencies();
  }, []);

  const listAgencies = () => {
    setLoader(true);
    _LIST_AGENCIES({ status: "1" }).then((res) => {
      if (res.status == "1") {
        setAgents(res.data);
      } else {
        setAgents([]);
      }
      setLoader(false);
    });
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      return;
    }
    setLoader(true);
    _UPDATE_USER_LOGIN(formToObject(form)).then((res) => {
      if (res.status == "1") {
        form.reset();
        context.setAlertMsg(res.message || "Saved");
        if (props.onSuccess) props.onSuccess();
      } else {
        openDialog({
          title: "Error",
          message: res.message || "Error on Save",
        });
      }
      setLoader(false);
    });
  };

  const field = (fieldName) => props.dataSource[fieldName] || "";

  return (
    <>
      <Spin spinning={loader}>
        <Form
          method="post"
          noValidate
          validated={validated}
          onSubmit={handleFormSubmit}
        >
          <input type="hidden" name="id" value={field("id")} />
          {!props.agencyId ? (
            <Row>
              <Col md={3}>
                <PsLabel text="Agency" required />
              </Col>
              <Col md={9}>
                <Form.Control
                  as="select"
                  name="agent_id"
                  size="sm"
                  className="fw-bold form-select form-select-sm"
                  required
                  autoFocus
                >
                  <option value="">-Select-</option>
                  {agents.map((item) => (
                    <option
                      value={item.id}
                      selected={item.id == field("agent_id") ? "selected" : ""}
                    >
                      {item.company_name}
                      {" - "}
                      {item.mobile_no}
                    </option>
                  ))}
                </Form.Control>
              </Col>
            </Row>
          ) : (
            <input type="hidden" name="agent_id" value={props.agencyId} />
          )}
          <Row className="mt-2">
            <Col md={3}>
              <PsLabel text="Name" required />
            </Col>
            <Col md={3} className="pe-0">
              <Form.Control
                as="select"
                name="title"
                size="sm"
                className="fw-bold form-select form-select-sm"
                defaultValue={field("title")}
                autoFocus
                required
              >
                <option value="M/s">M/s</option>
                <option value="Mr">Mr</option>
                <option value="Mrs">Mrs</option>
                <option value="Miss">Miss</option>
                <option value="Dr">Dr</option>
                <option value="Master">Master</option>
              </Form.Control>
            </Col>
            <Col md={6} className="ps-0">
              <Form.Control
                type="text"
                name="name"
                placeholder="Name"
                defaultValue={field("name")}
                size="sm"
                className="fw-bold"
                autoComplete="off"
                required
              />
            </Col>
          </Row>
          <Row className="mt-2">
            <Col md={3}>
              <PsLabel text="Mobile" required />
            </Col>
            <Col md={9}>
              <Form.Control
                type="number"
                name="mobile"
                placeholder="Mobile"
                defaultValue={field("mobile")}
                size="sm"
                className="fw-bold"
                min="0"
                autoComplete="off"
                required
              />
            </Col>
          </Row>
          <Row className="mt-2">
            <Col md={3}>
              <PsLabel text="Email" />
            </Col>
            <Col md={9}>
              <Form.Control
                type="email"
                name="email"
                defaultValue={field("email")}
                placeholder="Mail Id"
                size="sm"
                className="fw-bold"
                autoComplete="off"
              />
            </Col>
          </Row>

          <Row className="mt-2">
            <Col md={3}>
              <PsLabel text="Commission" />
            </Col>
            <Col md={9}>
              <Form.Control
                type="text"
                name="percentage_of_commision"
                defaultValue={field("percentage_of_commision")}
                placeholder="% of Commission"
                size="sm"
                className="fw-bold"
                autoComplete="off"
              />
            </Col>
          </Row>

          <Row className="mt-2">
            <Col md={3}>
              <PsLabel text="Status" required />
            </Col>
            <Col md={9}>
              <Form.Control
                as="select"
                name="active_status"
                size="sm"
                defaultValue={field("active_status")}
                className="fw-bold form-select form-select-sm"
                required
              >
                <option
                  value="1"
                  selected={field("active_status") == "1" ? "selected" : ""}
                >
                  Active
                </option>
                <option
                  value="0"
                  selected={field("active_status") == "0" ? "selected" : ""}
                >
                  In-Active
                </option>
              </Form.Control>
            </Col>
          </Row>

          <Row className="mt-3">
            <Col md={12}>
              <div className="text-end">
                <a
                  href="javascript:;"
                  className="me-3 text-decoration-underline"
                  onClick={(e) => props.onHide && props.onHide()}
                >
                  Cancel
                </a>
                <Button
                  type="submit"
                  variant="contained"
                  startIcon={<CheckIcon />}
                  size="small"
                >
                  Save
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </Spin>
    </>
  );
};
const EditUserLoginForm = (props) => {
  return (
    <>
      <PsModalWindow size="md" title="Edit User Login" {...props}>
        {props.show && <EditUserLoginFormComponent {...props} />}
      </PsModalWindow>
    </>
  );
};
export default EditUserLoginForm;
